import React from 'react';
import { Link } from 'react-router-dom';
import './MobileConsulting.css';

const MobileConsulting = () => {
  return (
    <div className="consulting-container">
      <header className="consulting-header">
        <h1 className="title fade-in">Mobile Consulting Services</h1>
        <p className="subtitle slide-in" style={{ color: 'white' }}>
          Your trusted partner in mobile development
        </p>
      </header>

      <section className="consulting-content">
        <div className="content-section">
          <div className="text-content">
            <h2 className="section-title fade-in">Why Choose Our Mobile Consulting Services?</h2>
            <p className="section-text fade-in">
              We provide top-notch mobile solutions tailored to your business needs. From native apps to cross-platform development, we’ve got you covered!
            </p>
            <ul className="benefits-list fade-in">
              <li>Customized solutions for your business</li>
              <li>Experienced team of mobile developers</li>
              <li>Agile development methodology</li>
              <li>End-to-end project management</li>
              <li>Competitive pricing and flexible engagement models</li>
            </ul>
          </div>
          <div className="image-content">
            <img
              src="/images/female-worker-presenting-visual-templates-coworkers.jpg"
              alt="Mobile Consulting"
              className="content-image slide-in"
            />
          </div>
        </div>

        <div className="content-section">
          <div className="text-content">
            <h2 className="section-title fade-in">Our Expertise</h2>
            <ul className="expertise-list fade-in">
              <li>Native App Development (Android & iOS)</li>
              <li>Cross-platform Development (React Native, Flutter)</li>
              <li>Consulting on App Architecture and Performance Optimization</li>
              <li>Mobile App UI/UX Design</li>
              <li>Integration with APIs & Backend Services</li>
              <li>Mobile App Testing & QA</li>
              <li>App Store Optimization (ASO)</li>
              <li>Maintenance & Support</li>
            </ul>
          </div>
          <div className="image-content">
            <img
              src="/images/android.webp"
              alt="Expertise"
              className="content-image slide-in"
            />
          </div>
        </div>

        <div className="content-section">
          <div className="text-content">
            <h2 className="section-title fade-in">Our Process</h2>
            <p className="section-text fade-in">
              We follow a structured and transparent process to ensure the success of your mobile app project:
            </p>
            <ol className="process-list fade-in">
              <li>Requirement Analysis & Planning</li>
              <li>Wireframing & Prototyping</li>
              <li>Design & Development</li>
              <li>Testing & Quality Assurance</li>
              <li>Deployment & Launch</li>
              <li>Post-Launch Support & Maintenance</li>
            </ol>
          </div>
          <div className="image-content">
            <img
              src="/images/22.png"
              alt="Our Process"
              className="content-image slide-in"
            />
          </div>
        </div>
      </section>

      <footer className="consulting-footer">
        <p className="footer-text fade-in">Contact us today for a free consultation!</p>
        <Link to="/ContactPage" className="contact-button hover-effect slide-in">
          Get in Touch
        </Link>
      </footer>
    </div>
  );
};

export default MobileConsulting;